import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Grid, Button, Typography } from '@material-ui/core'
import IconPicker from '../../features/apps/AppComponents/IconPicker/IconPicker'
import { BackButtonNavBarStyles } from './BackButtonNavBarStyles'

export default function BackButtonNavBar({
  onClick,
  name,
  topMargin = { xs: 0, sm: 0, md: 0, lg: 0 },
}) {
  // topMargin is an object with keys for each breakpoint (xs, sm, md, lg) and values for the top margin in pixels.
  // This allows for responsive design where the top margin can change based on the screen size.
  const useStyles = BackButtonNavBarStyles(topMargin)
  const classes = useStyles()
  const history = useHistory()
  let onClickHandler = onClick

  useEffect(() => {
    if (!onClickHandler) {
      onClickHandler = () => history.goBack()
    }
  }, [])

  return (
    <Box className={classes.topBackBar}>
      <Button className={classes.backButton} onClick={onClickHandler}>
        <Grid container alignItems="center" direction="row">
          <Grid item>
            <div className={classes.iconButton}>
              <IconPicker iconName="fas fa-arrow-left" />
            </div>
          </Grid>
          <Grid item>
            <Typography className={classes.categoryTitle} variant="h3">
              {name}
            </Typography>
          </Grid>
        </Grid>
      </Button>
    </Box>
  )
}
